import { useContext } from 'react';
import { Button } from 'reactstrap';
import { QuestionConfigurationModal } from './modal/QuestionConfigurationModal';
import { NON_OVERRIDABLE_SELECTED_QUESTION_TOOLTIP } from './utils';
import { InputOverrideType, ConfigurationType, QuestionConfigurationButtonProps } from './types';
import { QuestionManagementContext } from '@features/question-management/QuestionManagementContainer';
import { useToggle } from '@hooks/useToggle';
import { getInputOverridableSelectedQuestions } from '@features/survey-question-list/utils';
import { SimpleTooltip } from '@g17eco/molecules/simple-tooltip';

export const QuestionConfigurationButton = (props: QuestionConfigurationButtonProps) => {
  const { name, disabled = false, onClick, ...modalProps } = props;
  const { setInputOverrideType, setMetricOverrideCode } = useContext(QuestionManagementContext);
  const [isOpen, toggleOpen] = useToggle(false);

  const inputOverridableQuestions = getInputOverridableSelectedQuestions(modalProps.selectedQuestions);
  const invalidInputOverrides =
    modalProps.configType === ConfigurationType.InputOverrides && !inputOverridableQuestions.length;

  const iconMapping: Partial<Record<ConfigurationType, string>> = {
    [ConfigurationType.MetricOverrides]: 'fa-square-question',
    [ConfigurationType.InputOverrides]: 'fa-input-numeric',
    [ConfigurationType.Tags]: 'fa-tags',
  }

  const handleClick = () => {
    setInputOverrideType(modalProps.selectedQuestions.length > 1 ? InputOverrideType.NumberScale : undefined);
    setMetricOverrideCode(modalProps.selectedQuestions.length > 1 ? 'verificationRequired' : undefined);
    if (onClick) {
      onClick();
      return;
    }
    toggleOpen();
  };

  return (
    <>
      <SimpleTooltip text={invalidInputOverrides ? NON_OVERRIDABLE_SELECTED_QUESTION_TOOLTIP : undefined}>
        <Button
          onClick={handleClick}
          disabled={disabled || invalidInputOverrides}
          data-testid={modalProps.configType === ConfigurationType.Tags ? 'bulk-action-add-tag-btn' : undefined}
        >
          {iconMapping[modalProps.configType] ? <i className={`fa-light ${iconMapping[modalProps.configType]} fs-5 me-2`}></i> : null}
          {name || modalProps.configType}
        </Button>
      </SimpleTooltip>
      {onClick ? null : <QuestionConfigurationModal isOpen={isOpen} toggleOpen={toggleOpen} {...modalProps} />}
    </>
  );
};
